export type PaymentCompletionStatus = "succeeded" | "failed" | "processing";

export type PaymentRecoveryOutcome = "succeeded" | "declined" | "unconfirmed";

export type PaymentRecoveryDecision = {
	outcome: PaymentRecoveryOutcome;
	shouldAcknowledge: boolean;
};

export type PaymentAttempt =
	| { type: "completed"; status: PaymentCompletionStatus; declineCode?: string; reason?: string }
	| { type: "request-failed" }
	| { type: "not-charged" }
	| { type: "lightbox-error" };

export const decidePaymentRecovery = (attempt: PaymentAttempt): PaymentRecoveryDecision => {
	if (attempt.type === "request-failed") {
		return { outcome: "unconfirmed", shouldAcknowledge: true };
	}
	if (attempt.type === "not-charged") {
		// Client-side tokenization failed before any charge (Spreedly/Authorize.net onError). Acknowledge so the
		// server fails the still-PENDING session; on those providers pendingSessionProvesNotCharged lets re-init
		// proceed, otherwise "Try again" is blocked by the lingering PENDING session.
		return { outcome: "declined", shouldAcknowledge: true };
	}
	if (attempt.type === "lightbox-error") {
		return { outcome: "unconfirmed", shouldAcknowledge: true };
	}
	if (attempt.status === "succeeded") {
		return { outcome: "succeeded", shouldAcknowledge: false };
	}
	if (attempt.status === "failed") {
		return { outcome: "declined", shouldAcknowledge: false };
	}
	return { outcome: "unconfirmed", shouldAcknowledge: false };
};

export const isPaymentResolved = (status: PaymentCompletionStatus): boolean => status !== "processing";
